import { Field, Formik } from 'formik';
import moment from 'moment';
import React from 'react';
import { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import ability, { Can } from '../../ability';
import ReactstrapFormikTextArea from '../../components/reactstrap-formik/ReactStrapFormikTextArea';
import StandardResponse from '../../models/standard-response';
import DriverService from '../../services/driver/driver-service';
import { IAddNotesModalProps } from '../../types/propTypes';
import { IAddNotesForm, IAddNotesModalState } from '../../types/stateTypes';
import { regionDateAndTime } from '../../utils';
import { Common } from '../../utils/constants';
import { AddNotesValidationSchema } from '../../validation/driver/driver-validation';

class AddNotesModal extends Component<IAddNotesModalProps, IAddNotesModalState> {
    private driverService: DriverService;

    constructor(props) {
        super(props);
        this.state = {
            driverNotes: [],
            key: 0,
        };
        this.driverService = new DriverService();
    }

    private initialValues: IAddNotesForm = {
        remark: '',
    };

    async componentDidMount() {
        if (
            ability.can(Common.Actions.ADD_NOTE, Common.Modules.DRIVERS.ACCOUNTS) ||
            ability.can(Common.Actions.VIEW_NOTE, Common.Modules.DRIVERS.ACCOUNTS)
        ) {
            await this.getNotes();
        }
    }

    handleSubmit = async (values) => {
        const { driverDetails } = this.props;
        const inputData = {
            remark: values.remark,
        };
        await this.driverService
            .addNote(driverDetails.id, inputData)
            .then(async (res: StandardResponse<number>) => {
                this.initialValues = {
                    remark: '',
                };
                toast.success(res.Messages);
                await this.getNotes();
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
    };

    getNotes = async () => {
        const { driverDetails } = this.props;

        await this.driverService
            .getNotes(driverDetails.id)
            .then(async (res: StandardResponse<string>) => {
                if (res.Data) {
                    let notes = res.Data;
                    let notesArray = notes.split('[#NL#]');

                    let notesData = notesArray.reduce((filteredArray: Array<any>, note: string) => {
                        let notes = note.split('[#BR#]');
                        let splitArray = notes;
                        let date = splitArray[0];
                        let noteObj;
                        if (date !== 'Invalid date') {
                            noteObj = {
                                date,
                                email: splitArray[1],
                                note: splitArray[2],
                            };
                        } else {
                            noteObj = {
                                date: '',
                                email: '',
                                note: note,
                            };
                        }
                        filteredArray.push(noteObj);

                        return filteredArray;
                    }, []);

                    this.setState({ driverNotes: notesData, key: Math.random() });
                }
            })
            .catch((m) => {
                if (m.response && m.response.data && m.response.data.message) {
                    toast.error(m.response.data.message);
                } else {
                    toast.error(m.toString());
                }
            });
    };

    render() {
        const { t, showModal, closeModal, driverDetails } = this.props;

        return (
            <Modal show={showModal} onHide={closeModal} scrollable size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>{`${driverDetails.full_name} - ${t('driver.label.notes')}`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Can I={Common.Actions.ADD_NOTE} a={Common.Modules.DRIVERS.ACCOUNTS}>
                        <Formik
                            enableReinitialize
                            initialValues={this.initialValues}
                            validateOnChange={false}
                            validateOnBlur={false}
                            validationSchema={AddNotesValidationSchema()}
                            onSubmit={(values: IAddNotesForm) => this.handleSubmit(values)}
                            key={this.state.key}
                        >
                            {(props) => {
                                const { handleSubmit } = props;
                                return (
                                    <form
                                        id="addNotesForm"
                                        onSubmit={handleSubmit}
                                        noValidate
                                        autoComplete="off"
                                        className="mb-3"
                                    >
                                        <div className="form-goup">
                                            <Field
                                                name="remark"
                                                id="remark"
                                                placeholder={t('driver.label.newNote')}
                                                maxLength={500}
                                                rows={3}
                                                component={ReactstrapFormikTextArea}
                                                className="col-lg-10"
                                            />
                                        </div>

                                        <div className="form-goup">
                                            <button
                                                type="submit"
                                                name="addNote"
                                                className="btn btn-primary mr-2"
                                                title={t<string>('driver.label.addNote')}
                                            >
                                                <span>{t<string>('driver.label.addNote')}</span>
                                            </button>
                                        </div>
                                    </form>
                                );
                            }}
                        </Formik>
                    </Can>
                    {this.state.driverNotes.length > 0 && (
                        <div>
                            <h3>{t('driver.label.existingNotes')}</h3>
                            <table className="table table-bordered ">
                                {this.state.driverNotes.map((note, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex mb-2">
                                                    <div>{note.date}</div>
                                                    <div className="pl-3">{note.email}</div>
                                                </div>
                                                <div>{note.note}</div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </table>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}
export default AddNotesModal;
